import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const EMOJI = {
  fire: "🔥",
  eyes: "👀",
  hundred: "💯",
};

export default function WinnerReactions({ winnerId, dataTestId }) {
  const [counts, setCounts] = useState({ fire: 0, eyes: 0, hundred: 0 });
  const [mine, setMine] = useState(new Set());

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/winners/${winnerId}/reactions`);
        setCounts(data.counts);
        setMine(new Set(data.mine));
      } catch {
        /* noop */
      }
    })();
  }, [winnerId]);

  const tap = async (emoji) => {
    try {
      const { data } = await api.post(`/winners/${winnerId}/react`, { emoji });
      setCounts(data.counts);
      setMine((prev) => {
        const next = new Set(prev);
        if (data.action === "added") next.add(emoji);
        else next.delete(emoji);
        return next;
      });
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error("Sign in to react.");
      }
    }
  };

  return (
    <div className="flex items-center gap-1 mt-3" data-testid={dataTestId}>
      {Object.keys(EMOJI).map((k) => {
        const active = mine.has(k);
        return (
          <button
            key={k}
            type="button"
            onClick={() => tap(k)}
            className="tag-pill inline-flex items-center gap-1 text-xs transition-transform active:scale-95"
            style={{
              color: active ? "#76B82A" : "#F5F2E8",
              borderColor: active ? "#76B82A" : "rgba(245,242,232,0.2)",
              background: active ? "rgba(118,184,42,0.08)" : "transparent",
            }}
            data-testid={`react-${k}`}
          >
            {EMOJI[k]}
            <span className="font-mono">{counts[k] || 0}</span>
          </button>
        );
      })}
    </div>
  );
}
